import {Box, Button, Divider, Link, Skeleton, Typography} from '@mui/material';
import axios from 'axios';
import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation, useParams} from 'react-router-dom';
// import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {appConfig} from '@config';
// import ImamrezaCompetition from '@components/competitions/levels/imamreza';
// import ChannelHeader from '@components/network/ChannelHeader';
import CompetitionWordsHeader from '@components/competitions/CompetitionWordsHeader';
import {CompetitionWordsContext} from '@context/CompetitionWordsContext';
import {ICompetition} from '@components/competitions/ICompetitions';
import bg from '@components/competitions/levels/move/assets/images/bg-2.webp';
import Mission0 from './Mission0';
// import Mission1 from './Mission1';
import Mission2 from './Mission2';
import Mission3 from './Mission3';
import Mission4 from './Mission4';
import Mission5 from './Mission5';
import Mission6 from './Mission6';
import Mission7 from './Mission7';
import Mission8 from './Mission8';
import Mission9 from './Mission9';
import socketCompetition from '@sockets/competition';
import HeaderWithIcons from '@components/app/HeaderWithIcons';

export default function Move() {
	let referrer = '', socialGroup = '';
	const {t} = useTranslation();
	const location = useLocation();
	if (location.state) {
		referrer = location.state?.referrer ?? '';
		if (referrer == 'shad') {
			socialGroup = 'shad';
		}
	}
	const [competition, setCompetition] = useState<ICompetition>({});
	const [mission, setMission] = useState<number>(0);
	const [age, setAge] = useState<number>(1);
	const [choice, setChoice] = useState<number>(0);
	const [answer, setAnswer] = useState<number>(0);
	const [nashriye, setNashriye] = useState<string>('');
	const [description, setDescription] = useState<string>('');
	const [phone, setPhone] = useState<string>('');
	const [referralCode, setReferralCode] = useState<string>('');
	const [referrerFrom, setReferrerFrom] = useState<string>(referrer);
	const [social, setSocial] = useState<string>(socialGroup);
	
	let competitionObject = useLoaderData() as ICompetition;
	useEffect(() => {
		socketCompetition.connect();
	}, []);
	useEffect(() => {
		setCompetition(competitionObject);
	}, []);
	
	return (
		<>
			<CompetitionWordsContext.Provider value={{
				competition,
				mission,
				setMission,
				age,
				setAge,
				answer,
				setAnswer,
				choice,
				setChoice,
				nashriye,
				setNashriye,
				description,
				setDescription,
				phone,
				setPhone,
				referralCode,
				setReferralCode,
				social,
				setSocial,
				referrerFrom
			}}>
				<Box className="w-full flex justify-center flex-col">
					{/*<CompetitionWordsHeader/>*/}
					<HeaderWithIcons title={competition.name ?? <Skeleton className="w-24"/>} home={true}
					                 backUrl={'/competition/2'}/>
					<Box
						// className="flex flex-col w-full h-[calc(100vh-70px)] bg-no-repeat bg-cover overflow-hidden justify-center align-middle"
						className="flex flex-col w-full h-[calc(100vh-55px)] bg-no-repeat bg-cover overflow-y-scroll justify-center"
						sx={{
							backgroundImage: `url(${bg})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover'
						}}
					>
						{
							// Object.keys(competition).length > 0 && Object.keys(questions).length > 0 && (
							// Object.keys(competition).length > 0 &&
							mission == 0 && (
								<Mission0/>
							)
						}
						{/*{*/}
						{/*	mission == 1 && (*/}
						{/*		<Mission1/>*/}
						{/*	)*/}
						{/*}*/}
						{
							mission == 2 && (
								<Mission2/>
							)
						}
						{
							mission == 3 && (
								<Mission3/>
							)
						}
						{
							mission == 4 && (
								<Mission4/>
							)
						}
						{
							mission == 5 && (
								<Mission5/>
							)
						}
						{
							mission == 6 && (
								<Mission6/>
							)
						}
						{
							mission == 7 && (
								<Mission7/>
							)
						}
						{
							mission == 8 && (
								<Mission8/>
							)
						}
						{
							mission == 9 && (
								<Mission9/>
							)
						}
					</Box>
				</Box>
			</CompetitionWordsContext.Provider>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function wordsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}move/${data.params.competitionId}`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
